import { logEvent } from 'config/tracking';
import { FC, useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { useSessionStore } from 'stores/session';
import { TrackingEventName } from 'utils/types/amplitude';
import Modals from '../components/Modals';
import TrialReminderModal from '../components/Modals/TrialReminderModal';
import ConnectedRoutes from './ConnectedRoutes';
import DisconnectedRoutes from './DisconnectedRoutes';

const Routes: FC = () => {
    const { pathname } = useLocation();
    const userIsConnected = Boolean(useSessionStore((s) => s.user));

    useEffect(() => {
        logEvent({ name: TrackingEventName.PAGE_VIEW, params: { screen_name: pathname } });
    }, [pathname]);

    return userIsConnected ? <ConnectedRoutes /> : <DisconnectedRoutes />;
};

const Router: FC = () => (
    <BrowserRouter>
        <Routes />
        <Modals />
        <TrialReminderModal />
    </BrowserRouter>
);

export default Router;
